import { ButtonLink } from '@app/components/base/ButtonLink';
import EditIcon from '@mui/icons-material/Edit';
import { useIntl } from 'react-intl';

interface EditButtonProps {
  readonly to: string;
}

export const EditButton = ({ to }: EditButtonProps) => {
  const { formatMessage } = useIntl();

  return (
    <ButtonLink to={to} variant="outlined" startIcon={<EditIcon />}>
      {formatMessage({
        id: 'common.actions.edit',
        defaultMessage: 'Editar',
      })}
    </ButtonLink>
  );
};
